// Animación "vuela al carrito": un punto sale del producto tocado hacia el
// botón del carrito, que rebota. Puro DOM, sin dependencias.
export function flyToCart(fromEl) {
  try {
    if (!document.getElementById('fly-to-cart-style')) {
      const s = document.createElement('style');
      s.id = 'fly-to-cart-style';
      s.textContent = `@keyframes cartBump{0%{transform:scale(1)}30%{transform:scale(1.25)}60%{transform:scale(.92)}100%{transform:scale(1)}}.cart-bump{animation:cartBump .4s ease}`;
      document.head.appendChild(s);
    }

    const cart = document.querySelector('.floating-cart-button');
    if (!fromEl || !cart) return;

    const a = fromEl.getBoundingClientRect();
    const b = cart.getBoundingClientRect();
    const size = 28;

    const dot = document.createElement('div');
    Object.assign(dot.style, {
      position: 'fixed',
      left: (a.left + a.width / 2 - size / 2) + 'px',
      top: (a.top + a.height / 2 - size / 2) + 'px',
      width: size + 'px', height: size + 'px', borderRadius: '50%',
      background: '#6b7280', boxShadow: '0 6px 16px rgba(0,0,0,0.35)',
      zIndex: 99999, pointerEvents: 'none',
      transition: 'transform 0.6s cubic-bezier(0.5,-0.2,0.3,1), opacity 0.6s ease',
      transform: 'translate(0,0) scale(1)', opacity: '1',
    });
    document.body.appendChild(dot);

    const dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    const dy = (b.top + b.height / 2) - (a.top + a.height / 2);

    requestAnimationFrame(() => {
      dot.style.transform = `translate(${dx}px, ${dy}px) scale(0.2)`;
      dot.style.opacity = '0.5';
    });

    let done = false;
    const cleanup = () => {
      if (done) return; done = true;
      dot.remove();
      setTimeout(() => cart.classList.remove('cart-bump'), 400);
    };
    dot.addEventListener('transitionend', () => { cart.classList.add('cart-bump'); cleanup(); }, { once: true });
    setTimeout(cleanup, 1200); // respaldo
  } catch (e) { /* noop */ }
}
